<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
    <div class="container-header-inner">

        <div class="title-wrapper">
            <div>
                <h1 class="title-default">Cadastro de Serviço</h1>
                <p class="welcome-message">
                    <button mat-icon-button (click)="cancelar()">
                        <mat-icon>arrow_back</mat-icon>
                    </button>
                    Gerenciamento de serviços
                </p>
            </div>
        </div>

        <form [formGroup]="form">
            <!-- Dados Gerais -->
            <div class="section-container">
                <div class="section-title">
                    <mat-icon>info</mat-icon>
                    <span>Dados Gerais</span>
                </div>

                <div class="row">
                    <div class="col-12 col-md-6">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Descrição</mat-label>
                            <input matInput type="text" formControlName="descricao"
                                placeholder="Descrição do serviço" maxlength="255">
                            @if(form.get('descricao')?.hasError('required') && form.get('descricao')?.touched) {
                            <mat-error>Descrição é obrigatória</mat-error>
                            }
                            @if(form.get('descricao')?.hasError('minlength') && form.get('descricao')?.touched) {
                            <mat-error>Mínimo de 3 caracteres</mat-error>
                            }
                        </mat-form-field>
                    </div>
                    <div class="col-12 col-md-3">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Código</mat-label>
                            <input matInput type="text" formControlName="codigo"
                                placeholder="Código do serviço" maxlength="50">
                        </mat-form-field>
                    </div>
                    <div class="col-12 col-md-3 d-flex align-items-center">
                        <mat-slide-toggle class="app-toggle-compact" formControlName="isAtivo">Ativo</mat-slide-toggle>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12 col-md-4">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Preço</mat-label>
                            <input matInput formControlName="preco" [currencyMask]="currencyMask">
                        </mat-form-field>
                    </div>
                    <div class="col-12 col-md-4">
                        @if(listaUnidadeMedida) {
                        <app-select-pesquisavel label="Unidade de Medida"
                            [offlineList]="listaUnidadeMedida"
                            [control]="$any(form.get('idUnidadeMedida'))"
                            idField='idUnidadeMedida' nameField='descricao' placeholder="Selecione..."
                            [isOptional]="true">
                        </app-select-pesquisavel>
                        }
                    </div>
                    <div class="col-12 col-md-4">
                        @if(listaTipoItemSped) {
                        <app-select-pesquisavel label="Tipo de Item SPED"
                            [offlineList]="listaTipoItemSped"
                            [control]="$any(form.get('idTipoItemSped'))"
                            idField='id' nameField='descricao' placeholder="Selecione..."
                            [isOptional]="true">
                        </app-select-pesquisavel>
                        }
                    </div>
                </div>

                <div class="row">
                    <div class="col-12 col-md-6">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Código Tributação Nacional</mat-label>
                            <input matInput type="text" inputmode="numeric"
                                formControlName="codigoTributacaoNacionalServico"
                                [mask]="masks.codigoTributacaoNacional"
                                placeholder="Ex: 01.01.01"
                                (keydown)="onCodigoKeydown($event)"
                                (blur)="onCodigoTribNacionalBlur()">
                            @if(form.get('codigoTributacaoNacionalServico')?.value) {
                            <button mat-icon-button matSuffix type="button" (click)="limparTributacaoNacional()"
                                matTooltip="Limpar">
                                <mat-icon>cleaning_services</mat-icon>
                            </button>
                            }
                            <button mat-icon-button matSuffix type="button" (click)="pesquisarTributacaoNacional()"
                                matTooltip="Pesquisar código de tributação nacional">
                                <mat-icon>search</mat-icon>
                            </button>
                        </mat-form-field>
                    </div>
                    <div class="col-12 col-md-6">
                        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100 mb-3">
                            <mat-label>Código LC 116</mat-label>
                            <input matInput type="text" formControlName="codigoTributacaoNacionalServicoLc116"
                                [mask]="masks.lc116"
                                placeholder="Derivado do código de tributação">
                            @if(form.get('codigoTributacaoNacionalServicoLc116')?.value) {
                            <button mat-icon-button matSuffix type="button" (click)="limparLc116()"
                                matTooltip="Limpar LC 116">
                                <mat-icon>cleaning_services</mat-icon>
                            </button>
                            } @else if(form.get('codigoTributacaoNacionalServico')?.value) {
                            <button mat-icon-button matSuffix type="button" (click)="resyncLc116()"
                                matTooltip="Preencher LC 116 a partir do código de tributação">
                                <mat-icon>sync</mat-icon>
                            </button>
                            }
                            <mat-hint>Derivado do código de tributação</mat-hint>
                        </mat-form-field>
                    </div>                                                            
                </div>  
                
                <div class="row">
                    <div class="col-12 col-md-6">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Código Municipal Complementar</mat-label>
                            <input matInput type="text" formControlName="codigoMunicipalComplementar"
                                placeholder="Código municipal" maxlength="50">
                        </mat-form-field>
                    </div>  
                    <div class="col-12 col-md-6">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>NBS</mat-label>
                            <input matInput type="text" inputmode="numeric"
                                formControlName="nbs"
                                [mask]="masks.nbs"
                                placeholder="Ex: 1.0101.10.00"
                                (keydown)="onCodigoKeydown($event)">
                            @if(form.get('nbs')?.value) {
                            <button mat-icon-button matSuffix type="button" (click)="limparNbs()"
                                matTooltip="Limpar">
                                <mat-icon>cleaning_services</mat-icon>
                            </button>
                            }
                            <button mat-icon-button matSuffix type="button" (click)="pesquisarNbs()"
                                matTooltip="Pesquisar NBS">
                                <mat-icon>search</mat-icon>
                            </button>
                        </mat-form-field>
                    </div>
                </div>
            </div>

            <!-- Informações Complementares -->
            <div class="section-container mt-4">
                <div class="section-title">
                    <mat-icon>description</mat-icon>
                    <span>Informações Complementares</span>
                </div>

                <div class="row">
                    <div class="col-12 col-md-12">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Descrição Complementar</mat-label>
                            <textarea matInput formControlName="descricaoComplementar" rows="3"
                                placeholder="Descrição complementar do serviço"></textarea>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-md-12">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Observação</mat-label>
                            <textarea matInput formControlName="observacao" rows="3"
                                placeholder="Observações sobre o serviço"></textarea>
                        </mat-form-field>
                    </div>
                </div>
            </div>
        </form>

    </div>
</div>

<app-footer-action [isLoadingSalvar]="isLoadingSalvar" (cancelar)="cancelar()"
    (salvar)="salvar()"></app-footer-action>
